/** Minimum height of a tappable control (HACCP mobile-first: 48px touch targets). */
export const TOUCH_TARGET_PX = 48;
